import $ from 'jquery';
import React from 'react';
import Emoticon from './Emoticon.react';
import EmoticonsPanel from './EmoticonsPanel.react';
import EmoticonsStore from '../../stores/EmoticonsStore';
import EmoticonsActionCreators from '../../actions/EmoticonsActionCreators';
import requestFrame from 'request-frame';
// requestAnimationFrame polyfill
const request = requestFrame('request'); // requestAnimationFrame polyfill

function getEmoticonsState() {
  return {
    pageId: EmoticonsStore.getPageId(),
    page: EmoticonsStore.getPage(),
    loading: EmoticonsStore.isLoading(),
  };
}

class EmoticonsContainer extends React.Component {
	static displayName = 'EmoticonsContainer';
	state = getEmoticonsState();

	componentDidMount() {
	  EmoticonsStore.addChangeListener(this._onChange);

	  const _this = this;
	  // ielādi veic tad, kad ir attēlots pārējais DOM
	  request(() => {
	    EmoticonsActionCreators.loadEmoticonsPage(_this.state.pageId);
	  });
	}

	componentWillUnmount() {
	  EmoticonsStore.removeChangeListener(this._onChange);
	}

	render() {
	  return (
  <div className={`emoticons-container emoticons-container-${this.props.orientation}`}>
    <EmoticonsPanel
      addEmoticon={this.props.addEmoticon}
      page={this.state.page}
      pageId={this.state.pageId}
      loading={this.state.loading}
      isOpen={this.props.isOpen}
    />
  </div>
	  );
	}

	_onChange = () => {
	  this.setState(getEmoticonsState());
	};
}

module.exports = EmoticonsContainer;
